import React, { useState } from "react";
import API from "../../api/axios";
import { useNavigate } from "react-router-dom";

export default function Register() {
  const [agree, setAgree] = useState(false);

  const [form, setForm] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    password: "",
    fk_roles_id: 1, // Default role (adjust as needed)
  });

  const navigate = useNavigate();

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!agree) {
      alert("You must agree to the subscription fee to proceed.");
      return;
    }
    try {
      const res = await API.post("/register", form);
      if (res.data.status) {


          try {
            const response = await API.post("/create-checkout", {
              amount: "200",
              currency: "GBP",
              email : form.email,
              id:res.data.data.id,
            });

            const checkoutUrl = response.data.data.checkout_url;
            window.location.href = checkoutUrl; // Redirect to Revolut hosted payment page
          } catch (error) {
            console.error("Checkout failed:", error);
            alert("Unable to start checkout.");
          }



        // const checkoutRes = await API.post(
        //     'https://sandbox-merchant.revolut.com/api/1.0/orders',
        //     {
        //       amount: 200,
        //       currency: "GBP",
        //       description: "Individual Subscription",
        //       capture_mode: 'AUTOMATIC',
        //       customer_email: form.email,
        //       merchant_order_ext_ref : "1234567890",
        //       complete_url : "https://www.18verified.com/payment-success",
        //       cancel_url : "https://www.18verified.com/payment-cancel",
        //     },
        //     {
        //       headers: {
        //         Authorization: `Bearer sk_07gIApbbRhBEOLip7LG7_4rcpoTqoO3Mytyt2Dbj4vLFlHLjaqBKDsCa7GkSJNj5`,
        //         'Content-Type': 'application/json',
        //       },
        //     }
        // );


        // const { checkout_url } = checkoutRes.data;
        //
        // // Step 2: Open Revolut checkout widget
        // const revolut = window.RevolutCheckout({
        //   locale: "en",
        //   publicToken: "pk_CI7QacKbluQssuEFv07pAmjk8SoqE9202fhyy8N4cuFtsZEB", // Replace with your actual public key
        //   checkoutUrl: checkout_url,
        //   redirectUrl: window.location.origin + "/login", // or success page
        // });
        //
        // revolut.mount("#revolut-widget");
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      console.error(err);
      alert("Registration or Payment failed");
    }
  };


  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#F7EBFC] px-4">
      <img src="logo.png" alt="" srcset="" className="max-w-[200px] w-full mb-6"/>
      <form
        onSubmit={handleSubmit}
        className="bg-[#E3BCF4] p-8 rounded-2xl shadow-xl w-full max-w-md"
      >
        <h2 className="text-2xl font-semibold text-center mb-6 text-[#9B20AC]">
          create a account
        </h2>

        <div className="space-y-4">
          <input
            name="firstname"
            placeholder="First Name"
            onChange={handleChange}
            className="w-full px-4 py-2 border border-[#9B20AC] rounded-[12px] focus:outline-none focus:ring-1 focus:ring-[#9C27B0] placeholder:text-["
          />
          <input
            name="lastname"
            placeholder="Last Name"
            onChange={handleChange}
            className="w-full px-4 py-2 border border-[#9B20AC] rounded-[12px] focus:outline-none focus:ring-1 focus:ring-[#9C27B0]"
          />
          <input
            name="email"
            placeholder="Email"
            type="email"
            onChange={handleChange}
            className="w-full px-4 py-2 border border-[#9B20AC] rounded-[12px] focus:outline-none focus:ring-1 focus:ring-[#9C27B0]"
          />
          <input
            name="phone"
            placeholder="Phone"
            onChange={handleChange}
            className="w-full px-4 py-2 border border-[#9B20AC] rounded-[12px] focus:outline-none focus:ring-1 focus:ring-[#9C27B0]"
          />
          <input
            name="password"
            type="password"
            placeholder="Password"
            onChange={handleChange}
            className="w-full px-4 py-2 border border-[#9B20AC] rounded-[12px] focus:outline-none focus:ring-1 focus:ring-[#9C27B0]"
          />
        </div>
        <div className="text-s font-semibold text-left mb-6 text-[#9B20AC]">
          <div className="text-center text-[#000000]"><br></br>18Verified Subscription</div>
          <div><br></br>✓ once with your credit card or ID<br></br><br></br></div>
          <div>✓ Get instant access to all participating 18+ websites<br></br><br></br></div>
          <div>✓ Just £2/month — no per-site fees<br></br><br></br></div>
          <div>✓ Your subscription keeps your age verified across all platforms. Simple, secure, and private.<br></br><br></br></div>
          <div>✓️ cancel anytime<br></br><br></br></div>
          <div>✓ 18verified LTD shown on bank statements<br></br></div>
        </div>
        <div className="flex items-center mt-4">
          <input
              type="checkbox"
              id="agree"
              checked={agree}
              onChange={(e) => setAgree(e.target.checked)}
              className="mr-2"
          />
          <label htmlFor="agree" className="text-sm text-gray-700">
            I agree to pay £2 subscription fee per month
          </label>
        </div>
        <button
          type="submit"
          className="mt-6 w-full bg-[#9B20AC] hover:bg-[#8B1D9A] text-white font-medium py-2 rounded-lg transition duration-200"
        >
          Get verified now
        </button>

        <p className="mt-4 text-sm text-center text-gray-600">
          Already have an account?{" "}
          <span
            onClick={() => navigate("/login")}
            className="text-[#740d82] cursor-pointer hover:underline"
          >
            Login
          </span>
        </p>
        <div id="revolut-widget" className="mt-6"></div>
      </form>

    </div>
  );
}
